import { useQuery } from '@tanstack/react-query'

import { getShareBrandURLWeb } from './function'

export const useShareLinkWeb = (
  partnerId: number,
  customerId: number,
  hash: string
) => {
  return useQuery(
    ['shareLink', partnerId, customerId, hash],
    () => getShareBrandURLWeb(partnerId, customerId, hash),
    { enabled: false, staleTime: 0 }
  )
}
